import { render, staticRenderFns } from "./inspect-home-form.vue?vue&type=template&id=a0faff50&"
import script from "./inspect-home-form.vue?vue&type=script&lang=js&"
export * from "./inspect-home-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports